// eslint-disable-next-line import/prefer-default-export
export function snakeToCamel(value: string): string {
  return value.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

export function mathematicsRoundByStep(value: number, step: number): number {
  return Math.round(value / step) * step;
}

export function moneyNumberFormat(value: number): string {
  const number = new Intl.NumberFormat('cs', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(value);

  return number === 'NaN' ? '0.00' : number;
}
